import React, { useState } from "react";
import { Navigate } from 'react-router-dom';

import { withParams, log } from '../helper';

import NumberPad from '../components/NumberPad';
import ProgressBar from '../components/ProgressBar';

import { withTranslation } from 'react-i18next';

import { getDownloadFileContext } from '../models/File';

class Download extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      imagePath: '',
      videoPath: '',
      filename: '',
      filetype: '',
      url: '',
      error: '',
      isLoading: false,
      isOk: false,
    };
  }

  isImage = () => {
    return 'imagePath' in this.state && this.state.imagePath !== ''
  }

  isVideo = () => {
    return 'videoPath' in this.state && this.state.videoPath !== ''
  }

  isFilename = () => {
    return 'filename' in this.state && this.state.filename !== ''
  }

  isError = () => {
    return 'error' in this.state && this.state.error !== ''
  }
  updateImage = (imagePath, filename = '', filetype = '') => {
    this.setState(Object.assign({}, this.state, {
      imagePath,
      filename,
      filetype,
      url: imagePath,
      isOk: true,
      isLoading: false,
      error: '',
    }))
  }

  updateVideo = (videoPath, filename = '', filetype = '') => {
    this.setState(Object.assign({}, this.state, {
      videoPath,
      filename,
      filetype,
      url: videoPath,
      isOk: true,
      isLoading: false,
      error: '',
    }))
  }

  updateUrl = (url, filename = '', filetype = '') => {
    this.setState(Object.assign({}, this.state, {
      filename,
      filetype,
      url,
      isOk: true,
      isLoading: false,
      error: '',
    }))
  }

  updateError = (error) => {
    this.setState(Object.assign({}, this.state, {
      error,
      isLoading: false,
    }))
  }

  updateLoading = (value) => {
    this.setState(Object.assign({}, this.state, {
      isLoading: value,
      error: '',
    }))
  }

  success = (resp) => {
    if (resp.status !== 200) {
      this.updateError('Oops: Something Wrong. Try Again');
      return;
    }
    log(resp);
    if (resp.filetype.startsWith("image")) {
      this.updateImage(resp.url, resp.filename, resp.filetype);
    }
    else if (resp.filetype.startsWith("video")) {
      this.updateVideo(resp.url, resp.filename, resp.filetype);
    }
    else {
      this.updateUrl(resp.url, resp.filename, resp.filetype);
    }
  }

  handlePasswordChange = (value) => {
    this.setState({ password: value });
  };

  handlePasswordCheck = () => {
    const { code } = this.props.params;
    const { password } = this.state;

    this.updateLoading(true);

    getDownloadFileContext({
      key: code,
      password: password,
    })
      .then((resp) => resp)
      .then((resp) => resp.json())
      .then((resp) => this.success(resp));
  };

  render() {
    const { code } = this.props.params;
    const { t } = this.props;

    if (code.length !== 6) {
      return <Navigate to="/fallback" />;
    }

    return (
      <div className="container mt-5">
        <h1 className="text-center">{t('title')}</h1>

        {!this.state.isOk && (
          <div>
            <p><strong>{t('download_page_code')}</strong>{code}</p>
            <p><strong>{t('download_page_enter_passwd')}</strong></p>
            <NumberPad setValue={this.handlePasswordChange} />

            <div className="d-grid gap-2 my-5">
              <button className="btn btn-primary" type="button" onClick={this.handlePasswordCheck}>
                {t('download_page_submit')}
              </button>
            </div>
          </div>
        )}
        
        {this.isFilename() && (
          <p>
            <strong>{t('download_page_filename')}</strong>
            {this.state.filename}
          </p>
        )}

        {this.isError() && (
          <p className="text-danger">
            {this.state.error}
          </p>
        )}

        {this.state.isLoading && (
          <ProgressBar isLoading={true} />
        )}

        <div class="container d-flex align-items-center justify-content-center">
          {this.isImage() && (
            <img src={this.state.imagePath} alt={this.state.filename}/>
          )}
        
          {this.isVideo() && (
            <video style={{ "max-width": "100%", "max-height": "72vh" }}controls>
              <source src={this.state.videoPath} type={this.state.filetype}/>
            </video>
          )}
        </div>

        {this.state.url && (
          <div>
            <a target='_blank' rel='noopener noreferrer' href={this.state.url}>
              <div className="d-grid gap-2 my-5">
                <button className="btn btn-primary" type="button">
                  {t('download_page_download')}
                </button>
              </div>
            </a>
          </div>
        )}

      </div>
    );
  }
}

export default withTranslation()(withParams(Download));